import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type DeviceListDetails } from '../services/getDeviceListService'

export interface DeviceListDataState {
  isLoading: boolean
  loadingError: string | undefined
  DeviceListData: DeviceListDetails[] | undefined
  httpStatus: number | undefined
  totalCount: number
}

// Initial state of the slice
const initialState: DeviceListDataState = {
  isLoading: true,
  loadingError: undefined,
  DeviceListData: undefined,
  httpStatus: undefined,
  totalCount: 0
}

// Slice to return from action
export const DeviceDetailsListDataState = createSlice({
  name: 'ConfigurationListData',
  initialState,
  reducers: {
    DeviceDetailsListLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: undefined,
        DeviceListData: undefined,
        httpStatus: 0,
        totalCount: 0
      }
    },
    DeviceDetailsListUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        isLoading: false,
        loadingError: undefined,
        DeviceListData: action.payload.data,
        httpStatus: action.payload.httpStatus,
        totalCount: action.payload.total_count
      }
    },
    DeviceDetailsListErrorAction: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        httpStatus: action.payload.httpStatus,
        DeviceListData: undefined,
        totalCount: 0
      }
    }
  }
})

// Actions to export
export const {
  DeviceDetailsListLoadingAction,
  DeviceDetailsListUpdateAction,
  DeviceDetailsListErrorAction
} = DeviceDetailsListDataState.actions

export default DeviceDetailsListDataState.reducer
